import React, { useState } from 'react';
import { TextField, TextFieldProps, InputAdornment, IconButton } from '@mui/material';
import { FaKeyboard } from 'react-icons/fa';
import ArabicKeyboardDialog from '../arabic-keyboard-dialog';
import { isDesktop } from 'react-device-detect';

interface TextFieldWithArabicKeyboardProps extends Omit<TextFieldProps, 'onChange'> {
  value: string;
  onChange: (value: string) => void;
  showKeyboardButton?: boolean;
}

const TextFieldWithArabicKeyboard: React.FC<TextFieldWithArabicKeyboardProps> = ({
  value,
  onChange,
  ...textFieldProps
}) => {
  const [isKeyboardOpen, setIsKeyboardOpen] = useState(false);

  const handleOpenKeyboard = () => {
    setIsKeyboardOpen(true);
  };

  const handleCloseKeyboard = () => {
    setIsKeyboardOpen(false);
  };

  const handleKeyboardChange = (newValue: string) => {
    onChange(newValue);
  };

  return (
    <>
      <TextField
        {...textFieldProps}
        value={value}
        onChange={(e) => onChange(e.target.value)}
        InputProps={{
          ...textFieldProps.InputProps,
          endAdornment: isDesktop ? (
            <InputAdornment position="end">
              <IconButton
                onClick={handleOpenKeyboard}
                edge="end"
                aria-label="open arabic keyboard"
                sx={{ mr: -1 }}
              >
                <FaKeyboard />
              </IconButton>
              {textFieldProps.InputProps?.endAdornment}
            </InputAdornment>
          ) : (
            textFieldProps.InputProps?.endAdornment
          ),
        }}
      />

      {isKeyboardOpen && (
        <ArabicKeyboardDialog
          value={value}
          setValue={handleKeyboardChange}
          onClose={handleCloseKeyboard}
        />
      )}
    </>
  );
};

export default TextFieldWithArabicKeyboard;